import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function GuaranteeSection() {
  const revealRef = useScrollReveal();
  return <section className="bg-brand-violetDark py-10 px-[5%]" data-id="element-112">
      <div ref={revealRef} className="max-w-[680px] mx-auto reveal" data-id="element-113">
        <div className="bg-white/[0.03] border border-brand-gold/20 rounded-[24px] p-[48px] text-center relative overflow-hidden" data-id="element-114">
          <div className="absolute top-0 left-0 w-full h-[4px] bg-brand-gold" data-id="element-115" />

          <div className="text-[52px] mb-5" data-id="element-116">🛡️</div>
          <h2 className="font-display italic text-[36px] text-brand-cream mb-5" data-id="element-117">
            Tu inversión está protegida
          </h2>
          <p className="font-body font-light text-[16px] text-brand-cream/65 leading-[1.75]" data-id="element-118">
            Si en los 7 días siguientes a tu compra sientes que el protocolo no
            produjo ningún cambio en ti, te devolvemos tu dinero completo. Sin
            preguntas. Sin complicaciones. Así de seguros estamos de lo que
            hemos creado para ti.
          </p>
        </div>
      </div>
    </section>;
}